import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Pipe({ name: 'fieldInvalid', pure: false })
export class FieldInvalidPipe implements PipeTransform {
  transform(form: UntypedFormGroup, field: string): boolean {
    return (form.get(field)?.dirty ?? false) && (form.get(field)?.invalid ?? false);
  }
}
